import {styled} from '@linaria/react';
import React, {ComponentProps} from 'react';
import {COLORS} from '../../../constants/colors';
import {GLOBAL_KEYFRAMES} from '../../atoms/BaseStyles/keyFrames';
import {SliderPaginationDots} from '../SliderPaginationDots/SliderPaginationDots';
import {
  SlidesContainer,
  SpotlightSlider,
  SpotlightSliderProps,
} from './SpotlightSlider';

export const SpotlightAmbientSlider = <Slide extends object>({
  slides,
  CardComponent,
  BackgroundComponent,
  uniqueKey,
  isInitialAutoplayStopped,
}: SpotlightSliderProps<Slide>) => {
  return (
    <StyledSpotlightSlider
      slides={slides}
      CardComponent={CardComponent}
      BackgroundComponent={BackgroundComponent}
      BottomPaginationComponent={BottomPaginationComponent}
      uniqueKey={uniqueKey}
      isInitialAutoplayStopped={isInitialAutoplayStopped}
    />
  );
};

type BottomPaginationComponentType = ComponentProps<
  typeof SpotlightSlider
>['BottomPaginationComponent'];

const BottomPaginationComponent: BottomPaginationComponentType = ({
  currentSlide,
  scrollToSlide,
  maxPages,
  isAnimationStopped,
  isAnimationPaused,
  autoplayDuration,
  onStopAutomaticSlide,
}) => {
  return (
    <SliderPaginationWrapper>
      <StyledSliderPaginationDots
        isAnimationStopped={isAnimationStopped}
        isAnimationPaused={isAnimationPaused}
        maxPages={maxPages}
        currentSlide={currentSlide}
        scrollToSlide={scrollToSlide}
        enlargeActiveBullet={true}
        autoplayDuration={autoplayDuration}
        dotsColor={{
          active: 'rgba(255,255,255,0.4)',
          inactive: 'rgba(255,255,255,0.4)',
          progress: COLORS['Fill.White'],
        }}
        onClickDot={onStopAutomaticSlide}
      />
    </SliderPaginationWrapper>
  );
};

const CARDS_GAP = 8;

const StyledSpotlightSlider = styled(SpotlightSlider)`
  min-height: unset;
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;

  @media only screen and (max-height: 800px) {
    height: 100%;
  }

  & ${SlidesContainer} {
    scroll-padding: 0 16px;
    padding: 24px 16px 43px 16px;
    will-change: opacity;
    animation: ${GLOBAL_KEYFRAMES.cardsSliderAmbientFadeEnter} 500ms ease-in-out;

    @keyframes ${GLOBAL_KEYFRAMES.cardsSliderAmbientFadeEnter} {
      from {
        opacity: 0.8;
      }
      to {
        opacity: 1;
      }
    }

    > * {
      flex-shrink: 0;
      flex-basis: calc(100% - ${CARDS_GAP * 2}px);
      margin: 0 ${CARDS_GAP / 2}px;
    }
  }
`;

const SliderPaginationWrapper = styled.div`
  position: absolute;
  inset: auto 0 8px 0;
`;

const StyledSliderPaginationDots = styled(SliderPaginationDots)`
  margin-block: 14px;
  position: relative;
`;
